/**
 * The words lib/i18n.ts writes onto a page, in Dutch (Netherlands), for the /nl/ pages
 * (SEO_BRIEF_10A section 4). One entry per key of its `STRINGS`, keyed by the English exactly
 * as written there, in the informal register (je) of the server table
 * (server/app/i18n_strings_nl.py), whose words these match: the two page names are the same
 * in both tables, and the language model's message is the one the server shows.
 *
 * `{language}` is a language's name from Intl.DisplayNames in Dutch, capitalised ("Engels"),
 * so the sentence puts "het" before it, as Dutch does before a language's name.
 *
 * NATIVE SPEAKER REVIEW RECOMMENDED, as for the rest.
 */

export const NL: Readonly<Record<string, string>> = {
  "We need a quick check that you're a person. Tick the box below.":
    'We moeten even controleren of je een mens bent. Vink het vakje hieronder aan.',
  'Getting ready…': 'Voorbereiden…',
  'a SUP/PGS subtitle file': 'een SUP/PGS-ondertitelbestand',
  'a VobSub (IDX/SUB) subtitle file': 'een VobSub-ondertitelbestand (IDX/SUB)',
  'SUP to SRT': 'SUP naar SRT',
  'IDX/SUB to SRT': 'IDX/SUB naar SRT',
  'YouTube video': 'YouTube-video',
  'TikTok video': 'TikTok-video',
  'Instagram video': 'Instagram-video',
  'Facebook video': 'Facebook-video',
  'X video': 'X-video',
  'Vimeo video': 'Vimeo-video',
  'Twitch video': 'Twitch-video',
  'Loom video': 'Loom-video',
  'Dailymotion video': 'Dailymotion-video',
  'Rumble video': 'Rumble-video',
  'LinkedIn video': 'LinkedIn-video',
  'Translated into {language}.': 'Vertaald naar het {language}.',
  "1 line couldn't be translated and is left in {language}.":
    '1 regel kon niet worden vertaald en blijft in het {language}.',
  "{n} lines couldn't be translated and are left in {language}.":
    '{n} regels konden niet worden vertaald en blijven in het {language}.',
  "1 line couldn't be translated and is left as it was.":
    '1 regel kon niet worden vertaald en blijft zoals hij was.',
  "{n} lines couldn't be translated and are left as they were.":
    '{n} regels konden niet worden vertaald en blijven zoals ze waren.',
  'This file is already in {language}.': 'Dit bestand is al in het {language}.',
  podcast: 'podcast',
  "Translation and summaries aren't available right now.":
    'Vertalingen en samenvattingen zijn op dit moment niet beschikbaar.',
  "They'll be back by {reset}.": 'Uiterlijk om {reset} zijn ze weer beschikbaar.',
  'Transcription still works.': 'Transcriberen werkt nog steeds.',
  'Chinese (Mandarin)': 'Chinees (Mandarijn)',
  // lib/rating-prompt.ts, the optional pop-up after a copy or a download.
  'How was this tool?': 'Wat vond je van deze tool?',
  '{n} out of 5': '{n} van de 5',
  Bad: 'Slecht',
  'Very good': 'Heel goed',
  'Thanks for your rating.': 'Bedankt voor je beoordeling.',
  Close: 'Sluiten',
  // lib/option-panel.ts: the position grid, the colour's clear and its opacity.
  'Top left': 'Linksboven',
  'Top centre': 'Midden boven',
  'Top right': 'Rechtsboven',
  'Middle left': 'Midden links',
  'Middle centre': 'Midden',
  'Middle right': 'Midden rechts',
  'Bottom left': 'Linksonder',
  'Bottom centre': 'Midden onder',
  'Bottom right': 'Rechtsonder',
  'Leave as the style sets it': 'Laten zoals de stijl het instelt',
  Opacity: 'Dekking',
};
